export enum TaxProvider {
    VERTEX_CLOUD = 'vertex-cloud'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/tax-provider-type.enum.ts